$(document).ready(function () {

  const minSlider = $("#min-price");
  const maxSlider = $("#max-price");
  const minInput = $("#Filter-Price-GTE");
  const maxInput = $("#Filter-Price-LTE");
  const sliderTrack = $(".slider-track");
  const priceDisplay = $("#price-display");

  // Update the slider track position and display
  function updateSliderTrack() {
    const min = parseInt(minSlider.val());
    const max = parseInt(maxSlider.val());

    const minPercent = (min / 1000) * 100;
    const maxPercent = (max / 1000) * 100;

    sliderTrack.css({
      left: `${minPercent}%`,
      right: `${100 - maxPercent}%`,
    });

    priceDisplay.text(`${min} - ${max}`);
    minInput.val(min); // Update input field
    maxInput.val(max); // Update input field
  }

  // Update sliders when input fields are changed manually
  function syncSlidersFromInput() {
    let min = parseInt(minInput.val()) || 0;
    let max = parseInt(maxInput.val()) || 1000;

    // Ensure min and max constraints
    if (min < 0) min = 0;
    if (max > 1000) max = 1000;
    if (min >= max) min = max - 1;

    minSlider.val(min);
    maxSlider.val(max);
    updateSliderTrack();
  }

  // Handle slider changes
  minSlider.on("input", function () {
    if (parseInt(minSlider.val()) >= parseInt(maxSlider.val())) {
      minSlider.val(parseInt(maxSlider.val()) - 1); // Prevent overlap
    }
    updateSliderTrack();
  });

  maxSlider.on("input", function () {
    if (parseInt(maxSlider.val()) <= parseInt(minSlider.val())) {
      maxSlider.val(parseInt(minSlider.val()) + 1); // Prevent overlap
    }
    updateSliderTrack();
  });

  // Handle manual input changes
  minInput.on("input", syncSlidersFromInput);
  maxInput.on("input", syncSlidersFromInput);

  // Initialize with predefined values
  updateSliderTrack();
});